import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { ArrowLeft } from 'lucide-react';
import useUIStore from '../../../store/useUIStore';

const CustomerCreatePage = ({ sess = { uid: '', role: 'user' } }) => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useUIStore();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    tags: '',
    notes: '',
  });

  const getApiErrorMessage = (error, fallback) => {
    const data = error?.response?.data;
    return (
      data?.error?.error_user_msg ||
      data?.error?.message ||
      data?.message ||
      data?.error ||
      error?.message ||
      fallback
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('/chatbot/api/v1.0/create/customer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, uid: sess.uid }),
      });

      const result = await response.json();

      if (response.ok && (result?.success ?? true)) {
        showSuccess('Customer created successfully');
        navigate('/customers');
      } else {
        showError(result?.message || 'Failed to create customer');
      }
    } catch (error) {
      console.error('Error creating customer:', error);
      showError(getApiErrorMessage(error, 'Failed to create customer'));
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
        spacing={2}
        mb={2}
      >
        <Typography variant="h5">Create Customer</Typography>
        <Button variant="outlined" startIcon={<ArrowLeft size={16} />} onClick={() => navigate('/customers')}>
          Back
        </Button>
      </Stack>

      <Card>
        <CardContent>
          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Tags"
                  name="tags"
                  value={formData.tags}
                  onChange={handleChange}
                  placeholder="Comma separated tags"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Notes"
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  multiline
                  minRows={4}
                />
              </Grid>
            </Grid>

            <Stack direction="row" spacing={2} mt={3}>
              <Button type="submit" variant="contained">
                Create Customer
              </Button>
              <Button variant="outlined" onClick={() => navigate('/customers')}>
                Cancel
              </Button>
            </Stack>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CustomerCreatePage;
